module.exports = __webpack_public_path__ + "img/0Q3B8790-7_H_Foamcore.43b5b230.jpg";